var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelt = function SvgTelt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeMiterlimit: 10,
    d: "M8.586 3.972 6.866 1m.568 2.972L9.154 1M4.539 15H1L7.998 2.965 15 15h-3.542c-.657 0-1.225-.4-1.486-.98L8.3 10.98l-.3-.542-.301.542-1.674 3.04A1.64 1.64 0 0 1 4.54 15Z"
  })));
};
export default SvgTelt;